<template>
  <div :style="{ backgroundColor: $finColors.primaryLight }">
    <h2 v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
        v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
        class="pt-12 mb-4">
      Lesen und vertiefen
    </h2>
    <fin-work-in-progress v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                          v-style:paddingRight="$valueByBreakpoint($finPadding.right)"/>
  </div>
</template>

<script>
import FinWorkInProgress from "@/components/common/WorkInProgress/index"

export default {
  name: "finStrategyDetailsRead",
  components: {FinWorkInProgress}
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: $body-font-family;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark
}
</style>
